import { render } from "./educationData.vue?vue&type=template&id=1fec3490&scoped=true"
import script from "./educationData.vue?vue&type=script&lang=js"
export * from "./educationData.vue?vue&type=script&lang=js"

import "./educationData.vue?vue&type=style&index=0&id=1fec3490&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fec3490"]])

export default __exports__